import { FiExternalLink } from "react-icons/fi";
import * as React from 'react';
export default {
  FiExternalLink,
  React
};